import React, { Component } from 'react';
import {
    Container,
    Button, Row, Col
} from 'reactstrap';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import "react-table/react-table.css";
import "./Reports.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faCog, faEdit } from '@fortawesome/free-solid-svg-icons'
import CollapseCard from '../../components/CollapseCard/CollapseCard';
import PermissionWrapper from '../../auth/PermissionWrapper';
import SaveSearchModal from '../../components/SaveSearchModal/SaveSearchModal';
import CompanyContext from '../../auth/CompanyContext';

class Reports extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            reportsIsLoading: true,
            showModal: false,
            group_selections: '',
            current_date: this.props.available_dates.length - 1,
            previous_date: this.props.available_dates.length - 2,
            reportState: {
                isGlobal: false,
                isLatest: false,
                reportID: 0
            },
            savedSearches: [],
            reports: []
        };
        this.showModal = React.createRef();

        this.parseKey = (key) => {
            let retStr = key.replace(/_/g, " ");
            retStr = retStr.replace(/([a-z])([A-Z])/g, "$1 $2");
            retStr = retStr.replace(/\s([a-z])/g, function ($0, $1) { return $0.replace($1, $1.toUpperCase()); });
            retStr = retStr.replace(/^([a-z])?/, function ($0, $1) { return $0.replace($1, $1.toUpperCase()); })
            return retStr;
        }

        this.defaultColumn = {
            headerStyle: { textAlign: 'left' },
            style: { textAlign: 'left' }
        };
        this.leftAlignedHeaderProps = () => ({ style: { textAlign: 'left' } });
        this.leftAlignedCellProps = () => ({ style: { textAlign: 'left' } });

        this.savedSearchColumns = [
            {
                Header: 'Name',
                accessor: 'Name',
                filterable: false
            },
            {
                Header: 'Description',
                accessor: 'Description',
                filterable: false
            },
            {
                Header: 'Parameters',
                accessor: 'Parameters',
                filterable: false,
                show: false,
                className: 'parameters',
                Cell: row => {
                    if (row.value !== "") {
                        const params = JSON.parse(row.value);
                        let paramArr = [];
                        Object.keys(params).forEach(key => {
                            if (params[key] !== '' && params[key] !== false && params[key] != null) {
                                paramArr.push(<div key={key} className="paramEntry">
                                    <span className="paramKey">{this.parseKey(key) + ": "}</span>
                                    <span className="paramValue">{(params[key]) ? 'True' : params[key]}</span>
                                </div>)
                            }
                            // obj.params[params[key].name] = params[key].value;
                        });
                        return (<div className="paramContainer">{paramArr}</div>);
                        // params.forEach(param => {
                        //   if (param !== "") paramArr.push()
                        // })
                    } else {
                        return (<></>);
                    }
                }
            },
            {
                Header: 'Database',
                accessor: 'Database',
                width: 100,
                Cell: row => {
                    return <>{row.value !== null ? this.props.available_dates[this.props.available_dates.findIndex(item => item.date_key === String(row.value).split('|')[0])].date_string : ''}</>
                }
            },
            {
                Header: 'Created',
                accessor: 'Timestamp',
                width: 100,
                Cell: (props) => {
                    //props.value will contain your date
                    //you can convert your date here
                    const custom_date = props.value
                    let custom_date_format = custom_date.substr(5, 2) + '/' + custom_date.substr(8, 2) + '/' + custom_date.substr(0, 4)
                    return <>{custom_date_format}</>
                }
            },
            {
                Header: '',
                accessor: 'Type',
                width: 70,
                Cell: row =>
                (<Link className="btn btn-success" to={
                    {
                        pathname: 'search',//row.row.Type,
                        state: {
                            search_params: JSON.parse(row.row.Parameters !== '' ? row.row.Parameters : []),
                            current_date: row.row.Database != null ? row.row.Database.split('|')[0] : '',
                            previous_date: (row.row.Database != null && row.row.Database.split('|').length > 1) ? row.row.Database.split('|')[1] : '',
                            reportState: row.row
                        }
                    }
                }><FontAwesomeIcon icon={faPlay} /></Link>)
            },
            {
                Header: '',
                accessor: 'ID',
                width: 70,
                Cell: row =>
                (<>
                    <Button
                        key={'edit_' + row.value}
                        color="primary"
                        value={row.value}
                        onClick={this.openModal}
                        title="Edit"
                    ><FontAwesomeIcon icon={faEdit} /></Button>
                </>)
            },
        ];

        this.reportColumns = [
            {
                Header: 'Name',
                accessor: 'Name',
                filterable: false
            },
            {
                Header: 'Description',
                accessor: 'Description',
                filterable: false
            },
            {
                Header: 'Created',
                accessor: 'Timestamp',
                width: 100,
                Cell: (props) => {
                    const custom_date = props.value
                    let custom_date_format = custom_date.substr(5, 2) + '/' + custom_date.substr(8, 2) + '/' + custom_date.substr(0, 4)
                    return <>{custom_date_format}</>
                }
            },
            {
                Header: '',
                accessor: 'Function',
                width: 70,
                Cell: row => {
                    if (row.row._original.AutoRun) {
                        return (<Link className="btn btn-success" to={
                            {
                                pathname: 'reports/' + row.row.Function,
                            }
                        }><FontAwesomeIcon icon={faPlay} /></Link>)
                    } else {

                        return (<Link className="btn btn-primary" to={
                            {
                                pathname: 'reports/' + row.row.Function,
                            }
                        }><FontAwesomeIcon icon={faCog} /></Link>)
                    }
                }
            },
        ]
    }

    componentDidMount = () => {
        this.getReports();
        this.getSavedSearches();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    getSavedSearches = () => {

        fetch('/api/savedSearches/' + this.props.user, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {

                this.setState((prevState, props) => {

                    let return_value = {
                        savedSearches: results.data,
                        isLoading: false
                    };
                    return return_value;

                });
            });
    }

    getReports = () => {

        fetch('/api/reports/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {

                this.setState((prevState, props) => {

                    let return_value = {
                        reports: results.data,
                        reportsIsLoading: false
                    };
                    return return_value;

                });
            });
    }

    openModal = (e) => {
        const search = [...this.state.savedSearches].filter(item => item.ID === parseInt(e.target.value))[0];
        let current_date = this.state.current_date, previous_date = this.state.previous_date;
        if (search.Database != null) {
            current_date = this.props.available_dates.findIndex(i => i.date_key === search.Database.split('|')[0]);
            previous_date = this.props.available_dates.findIndex(i => i.date_key === search.Database.split('|')[1]);
            if (previous_date === -1) previous_date = Math.max(0, current_date - 1);
        }
        this.setState({
            group_selections: JSON.parse(search.Parameters),
            current_date: current_date,
            previous_date: previous_date,
            reportState: {
                ID: e.target.value,
                Name: search.Name,
                Description: search.Description,
                Database: search.Database,
                _original: { Global: search.Global }
            }
        }, () => this.showModal.current.modalOpen(true, false))
    }

    savedSearchesCallback = (val) => {
        this.getSavedSearches();
    }

    render() {
        if (!this.state.isLoading && !this.state.reportsIsLoading) {
            const publicSearches = [...this.state.savedSearches].filter(item => item.Global === true);
            const privateSearches = [...this.state.savedSearches].filter(item => item.Global === false);
            return (
                <PermissionWrapper {...this.props} allowedPermission="Reports">
                    <Container fluid className='p-9'>
                        <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                            <Row>
                                <Col md={12} className='text-center'>
                                    <h1>Reporting</h1>
                                </Col>
                            </Row>
                        </PermissionWrapper>
                        <Container fluid={true} className='p-0'>
                            <CollapseCard title="Available Reports" open={true}>
                                <ReactTable
                                    data={this.state.reports}
                                    columns={this.reportColumns}
                                    defaultColumn={this.defaultColumn}
                                    getTheadThProps={this.leftAlignedHeaderProps}
                                    getTdProps={this.leftAlignedCellProps}
                                    pageSize={this.state.reports.length}
                                    showPagination={false}
                                />
                            </CollapseCard>
                        </Container>
                        <SaveSearchModal ref={this.showModal}
                            clientToken={this.props.clientToken}
                            available_dates={this.props.available_dates}
                            group_selections={this.state.group_selections}
                            current_date={this.state.current_date}
                            previous_date={this.state.previous_date}
                            reportState={this.state.reportState}
                            type='search'
                            callback={this.savedSearchesCallback}
                            user={this.props.user} />
                        <Container fluid={true} className='p-0'>
                            <CollapseCard title="Public Queries" open={true}>
                                <ReactTable
                                    data={publicSearches}
                                    columns={this.savedSearchColumns}
                                    defaultColumn={this.defaultColumn}
                                    getTheadThProps={this.leftAlignedHeaderProps}
                                    getTdProps={this.leftAlignedCellProps}
                                    pageSize={publicSearches.length}
                                    showPagination={false}
                                />
                            </CollapseCard>
                        </Container>
                        <Container fluid={true} className='p-0'>
                            <CollapseCard title="Private Queries" open={true}>
                                <ReactTable
                                    data={privateSearches}
                                    columns={this.savedSearchColumns}
                                    defaultColumn={this.defaultColumn}
                                    getTheadThProps={this.leftAlignedHeaderProps}
                                    getTdProps={this.leftAlignedCellProps}
                                    pageSize={privateSearches.length}
                                    showPagination={false}
                                />
                            </CollapseCard>
                        </Container>
                    </Container>
                </PermissionWrapper>
            );
        } else {
            return (<></>
                // <h1>Reports</h1>
            )
        }
    }
}

export default Reports;
